import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modeSelect", "meetLinkSection"]

    connect() {
        this.updateMeetLinkVisibility()
    }

    modeChanged() {
        this.updateMeetLinkVisibility()
    }

    updateMeetLinkVisibility() {
        if (!this.hasMeetLinkSectionTarget) return
        if (!this.hasModeSelectTarget) {
            this.meetLinkSectionTarget.classList.remove("hidden")
            return
        }

        const mode = this.modeSelectTarget.value
        if (mode === "physical") {
            this.meetLinkSectionTarget.classList.add("hidden")
        } else {
            this.meetLinkSectionTarget.classList.remove("hidden")
        }
    }
}
